package com.budgeyet.fixtures

enum class DummyScenario {
    NoBudgetSetup,
    EmptyBudgetNoTransactions,
    HealthyMidMonth,
    NearLimitAmber,
    OverBudgetCoral,
    SoloBudgeter,
    FullHouseholdThreeMembers,
    LongTransactionHistory,
    SimulatedLoadingAndError
}
